(function () {
  function setup() {
    var root = document.querySelector('[data-six-tiers]');
    if (!root) return;
    var radios = root.querySelectorAll('input[type="radio"]');
    var sticky = document.querySelector('[data-six-sticky]');
    var stickyPrice = sticky ? sticky.querySelector('[data-six-sticky-price]') : null;

    function sync() {
      radios.forEach(function (r) {
        r.closest('.six-tier').classList.toggle('is-selected', r.checked);
        if (r.checked && stickyPrice) stickyPrice.textContent = r.getAttribute('data-price');
      });
    }
    radios.forEach(function (r) { r.addEventListener('change', sync); });
    sync();

    var shipped = (window.sixsenseTiers && window.sixsenseTiers.shipTo) || [];
    function applyCountry(name) {
      var ok = !!name && shipped.indexOf(name) !== -1;
      document.querySelectorAll('.six-ship-to').forEach(function (el) {
        if (ok) el.querySelector('.six-country').textContent = name;
        el.hidden = !ok;
      });
    }
    try { applyCountry(localStorage.getItem('detectedCountry')); } catch (e) {}
    document.addEventListener('geoDataUpdated', function (e) {
      applyCountry(e.detail && e.detail.userCountry);
    });

    var mainButton = document.querySelector('.product-form__cart-submit[data-add-to-cart]');
    if (sticky && mainButton) {
      var timer = null;
      function placeSticky() {
        timer = null;
        var r = mainButton.getBoundingClientRect();
        var inView = r.bottom > 0 && r.top < window.innerHeight && mainButton.offsetHeight > 0;
        sticky.hidden = inView;
      }
      function onScroll() {
        if (timer === null) timer = window.setTimeout(placeSticky, 80);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      placeSticky();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
